import { render, staticRenderFns } from "./otherRulePop.vue?vue&type=template&id=75594675&"
import script from "./otherRulePop.vue?vue&type=script&lang=js&"
export * from "./otherRulePop.vue?vue&type=script&lang=js&"
import style0 from "./otherRulePop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports